    <!-- V1.4 首页-退出重点关注待审核 -->
<template>
  <div class="exitSupervision">
    <div class="exitSupervision_box">
      <div class="exitSupervision_top">
        <div class="exitSupervision_top_title">{{ exitData.title }}</div>
        <div class="exitSupervision_top_nav line_bottom">
          <div class="exitSupervision_top_people">申请人： {{ exitData.applyName }}</div>
          <div class="exitSupervision_top_time">申请时间： {{ exitData.applyTime | filtTime }}</div>
        </div>
        <div class="exitSupervision_top_remark">
          <div class="remark">备注说明</div>
          <div class="remark_font">
            <div class="remark_font_size">
              {{ exitData.applyMemo }}
            </div>
          </div>
        </div>
        <div class="exitSupervision_top_remark">
          <div class="remark">上传附件</div>
          <div class="remark_upload">
            <better-scroll class="file_img" :scrollX="true" v-if="exitData.attach && exitData.attach.length">
              <div class="file_wrapper">
                <img
                    :src="value.url"
                    @click="showViewer(index, $event, exitData.attach.map(e => e.url))"
                    v-for="(value, index) in exitData.attach"
                    :key="index"
                  />
              </div>
            </better-scroll>
          </div>
        </div>
      </div>
      <div class="exitSupervision_bottom">
        <div class="result line_bottom">
          <div class="title">
            <div>企业评分信息</div>
          </div>
        </div>
        <div class="toBeRectified">
          <div class="companyName line_bottom">
            <div class="left">企业名称</div>
            <div class="right" @click="goTaskDetail">
              <span>{{ exitDataList.enterpriseName }}</span>
              <img src="../../../../assets/image/ic_jt_ck@2x.png" alt />
            </div>
          </div>
          <div class="jurisdiction line_bottom">
            <div class="left">所属辖区</div>
            <div class="right">{{ exitDataList.regionName }}</div>
          </div>
          <div class="supervisionDate line_bottom">
            <div class="left">进入重点关注日期</div>
            <!-- <div class="right" v-show='contentData.planTime'>{{'2019-11-18 15:30'|filtTime}}</div> -->
            <div class="right">{{ exitDataList.enteredTime | filtTime }}</div>
          </div>
          <div class="supervisionDate integrityIndex">
            <div class="left"><span>诚信指数</span></div>
            <div class="right">
              <span @click="goGradeDetail">评分详情</span>
              <img src="../../../../assets/image/ic_jt_ck@2x.png" alt />
            </div>
          </div>
          <div class="integrity_scored">
            <div class="integrity_scored_box">
              <div class="integrity_scored_current"><span class="current">{{ exitDataList.score }}</span> 分</div>
              <div class="integrity_scored_title">当前评分</div>
            </div>
            <div class="integrity_scored_box">
              <div class="integrity_scored_bringInto"><span class="bringInto">{{ exitDataList.enterScore }}</span> 分</div>
              <div class="integrity_scored_title">纳入评分</div>
            </div>
          </div>
          <div class="integrity_scored_box1"></div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="status" @click="changeBtn" >审核</div>
    </div>
      <!-- <div class="status" @click="changeBtn" v-show="!contentData.isHandle">我知道了</div> -->
      <!-- <div class="status saw"  v-show="contentData.isHandle">已知悉</div> -->
      <!-- <div class="status saw"  v-show="contentData.isHandle">已知悉</div> -->

    <!-- 审核 -->
    <van-popup
          class="examinePicker"
          v-model="isShowExaminePicker"
          position="bottom"
          closeable
          @close="retunThroughExamineActive"
          :style="{ minHeight: '232px'}"
        >
          <h5 class="examinePickerTitle">审核结果</h5>
          <div class="examineBtns">
            <div
              class="throughExamine"
              :class="{'active': isThroughExamine}"
              @click="changeThroughExamine"
            >通过</div>
            <div
              class="notThroughExamine"
              :class="{'active': isNotThroughExamine}"
              @click="changeNotThroughExamine"
            >不通过</div>
          </div>
          <div class="examineMiddleBox">
            <div class="examineOpinionBox" v-show="isThroughExamine">
              <van-checkbox v-model="checked" checked-color="#07c160">填写审核意见</van-checkbox>
            </div>
            <div class="notThroughExamineTitile" v-show="isNotThroughExamine">
              审核意见
              <span>必填</span>
            </div>
            <div v-show="checked" class="throughExamineTextBox">
              <!-- <van-field
                class="throughExamineText"
                v-model="throughExamineText"
                type="textarea"
                placeholder="请在这里输入您的审核意⻅"
              />-->
              <textarea
                name
                class="throughExamineText"
                placeholder="请在这里输入您的审核意⻅"
                v-model="throughExamineText"
                @blur="loseBlur"
                maxlength="120"
              >
             </textarea>
            </div>
          </div>
            <!-- :class="{'active': isThroughExamine || isNotThroughExamine}" -->
          <div
            class="submitBtn"
            @click="handleSubmitExamine"
            :class="{'activeBtn': showBtn}"
          >提交</div>
          <div class="cancelIcon">
            <div @click="cancelScenic">
              <img src="../../../../assets/integrity/ic_gb@3x.png" alt="">
            </div>
          </div>
        </van-popup>
  </div>
</template>

<script>
    import api from '../../../../service/modules/integrity';
    import betterScroll from '../../components/betterScroll';

    export default {
        components: {
            'better-scroll': betterScroll
        },
        data () {
            return {
                isShowExaminePicker: false, /** 审核弹窗 */
                checked: false,
                isThroughExamine: false,
                isNotThroughExamine: false,
                throughExamineText: '',
                exitData: {},
                exitDataList: {}
            }
        },
        created () {
            this.getSupervisionExit();
        },
        computed: {
            showBtn () {
                if ((this.isThroughExamine && this.checked && this.throughExamineText.trim() !== '') || (this.isThroughExamine && !this.checked) || (this.isNotThroughExamine && this.throughExamineText.trim() !== '')) {
                  return true;
                } else {
                  return false;
                }
            }
        },
        methods: {
            /** 企业名称 */
            goTaskDetail () {
                this.$router.push({
                    path: 'enterpriseDetail',
                    query: {
                        enterpriseId: this.exitDataList.enterpriseId
                    }
                })
            },
            /** 诚信指数详情 */
            goGradeDetail () {
                this.$router.push({
                    path: 'scoreDetails',
                    query: {
                        id: this.exitDataList.enterpriseId
                    }
                })
            },
            getSupervisionExit () {
                api.supervisionExit({ taskId: this.$route.query.taskId }).then(res => {
                    if (res.ret === 0) {
                        this.exitData = res.data;
                        this.exitDataList = (res.data && res.data.enterpriseDetail) || {};
                    }
                })
            },
            // 图片预览
            showViewer (index, event, imgList) {
                this.$router.push({
                  path: '/complaint/imagesView',
                  query: {
                    imageList:imgList|| [],
                    index
                  },
                })

                // this.$ImagePreview({
                //     images: imgList,
                //     startPosition: index,
                //     closeOnPopstate: true
                // });
            },
            /** 审核 */
            changeBtn () {
                this.isShowExaminePicker = true;
            },
            // 弹窗消失按钮状态取消
            retunThroughExamineActive () {
                this.checked = false
                this.isThroughExamine = false;
                this.isNotThroughExamine = false;
            },
            // 通过按钮事件
            changeThroughExamine () {
                this.isThroughExamine = true;
                this.isNotThroughExamine = false;
            },
            // 不通过按钮事件
            changeNotThroughExamine () {
                this.checked = true;
                this.isThroughExamine = false;
                this.isNotThroughExamine = true;
            },
            loseBlur () {
                // window.scroll(0, 0)
            },
            // 审核提交按钮事件
            handleSubmitExamine () {
                if (this.isThroughExamine && this.checked && this.throughExamineText.trim() !== '') {
                    /** 审核通过 填写备注 */
                    let parm = {
                        id: this.exitData.id,
                        reason: this.throughExamineText
                    }
                    api.supervisionAuditPass(parm).then(res => {
                        if (res.ret ===0 ) {
                            this.isShowExaminePicker = false;
                            this.isThroughExamine = false;
                            this.checked = false;
                            this.throughExamineText = '';
                            // this.$Toast({
                            //     message: '审核通过',
                            //     icon: 'passed'
                            // });
                            yyn.invokeJSB('closeWindow'); /** 跳转到tio首页 */
                            this.$Toast({
                                message: '处理成功',
                                icon: 'passed'
                            });
                        }
                    })
                } else if (this.isThroughExamine && !this.checked) {
                  /** 审核通过 不填写备注 */
                    let parm = {
                        id: this.exitData.id,
                        reason: ''
                    }
                    api.supervisionAuditPass(parm).then(res => {
                        if (res.ret ===0 ) {
                            this.isShowExaminePicker = false;
                            this.isThroughExamine = false;
                            this.checked = false;
                            this.throughExamineText = '';
                            // this.$Toast({
                            //     message: '审核通过',
                            //     icon: 'passed'
                            // });
                            yyn.invokeJSB('closeWindow'); /** 跳转到tio首页 */
                            this.$Toast({
                                message: '处理成功',
                                icon: 'passed'
                            });
                        }
                    })
                } else if (this.isNotThroughExamine && this.throughExamineText.trim() !== '') {
                    /** 审核不通过 */
                    let parm = {
                        id: this.exitData.id,
                        reason: this.throughExamineText
                    }
                    api.supervisionAuditRejected(parm).then(res => {
                        if (res.ret === 0) {
                            this.isShowExaminePicker = false;
                            this.isNotThroughExamine = false;
                            this.checked = false; 
                            this.throughExamineText = '';
                            this.examineDetailTips = false;
                            // this.$Toast({
                            //     message: '审核不通过',
                            //     icon: 'close'
                            // });
                            yyn.invokeJSB('closeWindow'); /** 跳转到tio首页 */
                            this.$Toast({
                                message: '处理成功',
                                icon: 'passed'
                            });
                        }
                    })
                }
            },
            cancelScenic () {
                this.isShowExaminePicker = false;
            }
        },
        
        // 时间搓
        filters: {
            filtTime (str) {
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + "-";
                var M =
                    (date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1) + "-";
                var D =
                    (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
                var h =
                    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
                var m =
                    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
                    ":";
                var s =
                    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
                let strDate = Y + M + D + h + m + s;
                return strDate;
            }
        }
    }
</script>

<style lang="less" scoped>
.exitSupervision {
  color: #333;
  width: 100%;
  min-height: 100%;
  background-color: #fbfbfb;
  padding: 21px 12px;
  box-sizing: border-box;
  position: absolute;
  padding-bottom: 74px;
  .exitSupervision_box {
    height: 100%;
    width: 100%;
    .exitSupervision_top {
      width: 100%;
      background-color: #fff;
      float: left;
      box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
      border-radius:3px;
      margin-bottom: 16px;
      .exitSupervision_top_title {
        font-size:16px;
        font-weight:600;
        color: #333;
        padding: 16px;
      }
      .exitSupervision_top_nav {
        padding: 0 16px 16px 16px;
        color: #666;
        font-size:14px;
        font-weight:400;
        .exitSupervision_top_people{
          margin-bottom: 12px;
        }
        .exitSupervision_top_time {
  
        }
      }
      .exitSupervision_top_remark {
  
        .remark {
          padding: 16px 16px 12px 12px;
          font-size:14px;
          font-weight:400;
          color: #999;
        }
        .remark_font {
          margin: 0 16px;
          background: #F8F8F8;
          color: #333333;
          font-weight:400;
          padding: 8px 16px;
          .remark_font_size {
            font-size:14px;
            line-height: 24px;
          }
        }
        .remark_upload {
          margin: 0 16px 16px;
          .file_img{
            width:100%;
            height:74px;
            position: relative;
            overflow: hidden;
            .file_wrapper{
              height:74px;
              white-space: nowrap;
              position:absolute;
              img{
                  width: 74px;
                  height: 74px;
                  display: inline-block;
                  margin-left: 8px;
                  border-radius: 3px;
              }
              img:nth-child(1){
                margin-left:0;
              }
            }
          }
        }
      }
    }
    .exitSupervision_bottom {
      width: 100%;
      // height: 100%;
      background-color: #fff;
      float: left;
      box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
      border-radius:3px;
      margin-bottom: 16px;
      .result {
        width: 100%;
        padding: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
          font-size: 14px;
          color: #333;
          font-weight: 600;
          display: flex;
          justify-content: space-between;
        }
      }
      .toBeRectified {
        width: 100%;
        height: 100%;
        .companyName,
        .jurisdiction,
        .supervisionDate {
          height: 62px;
          width: 100%;
          line-height: 62px;
          padding: 0 16px;
          font-size: 14px;
          display: flex;
          justify-content: space-between;
          .left {
            color: #999;
          }
        }
        .jurisdiction{
          .right{
            width: 160px;
            text-align: right;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .companyName {
          line-height: center;
          .right{
            display: flex;
            justify-content: space-around;
            span{
              display: inline-block;
              width: 160px;
              text-align: right;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            img{
              display: inline-block;
              width: 12px;
              height: 12px;
              margin-left: 4px;
              margin-top: 24px;
            }
          }
        }
        .integrityIndex {
          height: 60px;
          width: 100%;
          line-height: 60px;
          padding: 0 16px;
          font-size: 14px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left{
            // display: flex;
            // align-items: center;
          }
          .right {
            span {
              float: left;
            }
            img {
              display: inline-block;
              float: right;
              width: 12px;
              height: 12px;
              margin-left: 4px;
              margin-top: 24px;
            }
          }
        }
        .integrity_scored {
          margin: 12px 16px 0px 16px;
          display: flex;
          justify-content: space-around;
          .integrity_scored_box {
            .integrity_scored_current {
              color: #36B374;
              font-size: 10px;
              span {
                font-size: 20px;
                font-weight:bold;
              }
  
            }
            .integrity_scored_bringInto {
              color: #FF4D4D;
              font-size: 10px;
              span {
                font-size: 20px;
                font-weight:bold;
              }
            }
            .integrity_scored_title {
              margin-top: 8px;
              color: #999999;
              font-size:12px;
              font-weight:400;
            }
          }
        }
        .integrity_scored_box1 {
          height: 24px;
          background: #fff;
        }
      }
    }
  }
  .bottom {
    box-shadow:0px -2px 8px 0px rgba(0,0,0,0.03);
    width: 100%;
    height: 74px;
    background-color: #fff;
    padding: 12px;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    .status {
      border-radius: 3px;
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background-color: #36b374;
      color: #fff;
      font-size: 16px;
      font-weight: 600;
    }
    .saw {
      opacity: 0.5;
    }
  }
  .examinePicker {
      padding: 12px;
      .examinePickerTitle {
        padding: 8px 4px 0 4px;
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: bold;
      }

      .examineBtns::after {
        content: "";
        display: block;
        clear: both;
      }

      .examineBtns {
        padding: 0 4px;
        margin-bottom: 24px;

        > div {
          width: 64px;
          height: 28px;
          font-size: 12px;
          text-align: center;
          line-height: 28px;
          color: #36b374;
          border: 1px solid #36b374;
          border-radius: 2px;
          float: left;
        }

        > div.active {
          color: #fff;
          background-color: #36b374;
        }

        .throughExamine {
          margin-right: 12px;
        }
      }

      .examineMiddleBox {
        min-height: 75px;
        padding: 0 4px;
        .examineOpinionBox {
          margin-bottom: 16px;
          font-size: 14px;
          color: #666;
        }

        .notThroughExamineTitile {
          font-size: 16px;
          font-weight: bold;
          line-height: 20px;
          color: #333;

          > span {
            margin-left: 4px;
            font-size: 12px;
            font-weight: normal;
            color: #999;
          }
        }
        .throughExamineTextBox {
          margin-bottom: 24px;
          position:relative;
          .throughExamineText {
            margin-top: 10px;
            padding: 10px;
            height: 120px;
            border:none;
           resize: none;
            width: 94%;
            // overflow-y: scroll;
            font-size: 14px;
            line-height: 22px;
            color: #333333;
            background-color: #f5f5f5;
            border-radius: 4px;
          }
        }
      }

      .submitBtn {
        width: 100%;
        height: 50px;
        text-align: center;
        line-height: 50px;
        color: #fff;
        background-color: #9bd9ba;
        border-radius: 3px;
        font-size: 16px;
        font-weight: 500;
      }

      .activeBtn {
        background-color: #36b374;
      }
      .cancelIcon {
      width: 40px;
      height: 40px;
      position: absolute;
      background: #fff;
      z-index: 99;
      right: 0;
      top: 0;
      div {
        width: 20px;
        height: 20px;
        margin-top: 12px;
      }
    }
    }
}
</style>
